class GiftModal extends HTMLElement {
    form;
    trigger;
    button;
    characters;
    messageText;
    textArea;
    image;
    names;
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.trigger = document.querySelector('product-form .product-form__gift');
        this.button = this.querySelector('.product-form__gift');
        this.characters = this.querySelector('.gift-characters');
        this.messageText = this.querySelector('.gift-message');
        this.textArea = this.querySelector('textarea');
        this.names = {};
        this.form.addEventListener('change', this.handleInput.bind(this));
        this.trigger.addEventListener('click', this.update.bind(this));
        this.form.addEventListener('submit', this.addGift.bind(this));
        this.textArea.addEventListener('keyup', this.updateMessage.bind(this));
    }
    update = () => {
        this.button.dataset.mobilePrice = document.querySelector('product-form .product-form__submit').dataset.mobilePrice;
    };
    updateMessage = (e) => {
        const value = e.target.value;
        this.messageText.innerHTML = value === '' ? 'Enjoy Happy Napping from Bearaby! Blissful sleep is yours to keep.' : value;
        const length = 200 - value.length;
        this.characters.innerHTML = length + ' characters remaining';
    };
    handleInput = (e) => {
        const { value, name } = e.target;
        this.names[name] = value;
    };
    addGift = (e) => {
        e.preventDefault();
        this.button.setAttribute('disabled', 'true');
        this.button.classList.add('loading');
        const body = JSON.stringify({
            items: [{
                id: window.theme.product.currentVariant.id,
                quantity: 1,
                properties: { '__shopify_send_gift_card_to_recipient': 'on', ...this.names }
            }]
        });
        fetch('/cart/add.js', { ...window.theme.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                window.theme.cart.render();
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this.button.classList.remove('loading');
                this.button.removeAttribute('disabled');
                this.removeAttribute('open');
            });
    };
}
customElements.define('gift-modal', GiftModal);